import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { formatCurrency } from '../../risk-register/feching';

// ----------------------------------------------------------------------

export default function UserTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  currentItem,
  serialNumber,
}) {
  const {
    name,
    quantity,
    qr_and_barcode,
    iot_details,
    supplier,
    performed_by,
    remarks,
    unit,
    unit_price,
    availability,
    location_type,
    location,
    amount,
  } = row;
  const confirm = useBoolean();
  const popover = usePopover();
  const [deleteLoading, setDeleteLoading] = useState(false);

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>
        <TableCell>{serialNumber}</TableCell>
        <TableCell>{name}</TableCell>
        <TableCell>{qr_and_barcode}</TableCell>
        <TableCell>{iot_details}</TableCell>
        <TableCell>{`${supplier?.first_name} ${supplier?.last_name}`}</TableCell>
        <TableCell>{quantity}</TableCell>
        <TableCell>{unit}</TableCell>
        <TableCell>{formatCurrency(unit_price)}</TableCell>
        <TableCell>{availability === 1 ? 'Yes' : 'No'}</TableCell>
        <TableCell>{`${performed_by?.first_name} ${performed_by?.last_name}`}</TableCell>
        <TableCell>{location_type}</TableCell>
        <TableCell>{location}</TableCell>
        <TableCell>{formatCurrency(amount)}</TableCell>
        <TableCell>{remarks}</TableCell>
        <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            onEditRow(row);
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem>
      </CustomPopover>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure you want to delete?"
        action={
          <LoadingButton
            className="dark-button"
            loading={deleteLoading}
            variant="contained"
            color="error"
            onClick={async () => {
              setDeleteLoading(true);
              await onDeleteRow(row.id);
              setDeleteLoading(false);
              confirm.onFalse();
            }}
          >
            Delete
          </LoadingButton>
        }
      />
    </>
  );
}
UserTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
